import { Injectable } from '@angular/core';

import moment from 'moment';

@Injectable({ providedIn: 'root' })
export class DateConversionService {
    constructor() { }

    convertToDate(stringDate: string): Date {
        return moment(stringDate).utc().toDate();
    }

    // This method exists to cast date to a real date object due to the limitations of deserializing dates from JSON
    castToDate(date: Date | any | string): Date | null {
        if (!date) {
            return null;
        }
        const momentDate = moment(date).utc();
        return momentDate.isValid() ? momentDate.toDate() : null;
    }

    convertDateToString(dateObj: Date | moment.Moment | string): string {
        if (dateObj === null || dateObj === undefined || dateObj === '') {
            return '';
        }

        return moment(dateObj).utc().format("YYYY-MM-DD");
    }

    formatDateString(dateString: string): string {
        return dateString ? moment(dateString, "YYYY-MM-DD").utc().format("YYYY-MM-DD") : null;
    }

    formatDateStringUS(dateString: string): string {
        return dateString ? moment(dateString, "YYYY-MM-DD").utc().format("MM/DD/YYYY") : null;
    }

    safeParseDate(value: Date | string): Date | null {
        if (!value) {
            return null;
        }
        const date = new Date(value);
        return isNaN(date.getTime()) ? null : date;
    }
}
